const STEPS = [
  {
    n: "01",
    title: "Befaring",
    desc: "Vi kommer hjem til deg, kartlegger behovet og foreslår løsninger som faktisk lønner seg.",
  },
  {
    n: "02",
    title: "Tilbud",
    desc: "Du får et tydelig, skriftlig tilbud uten skjulte kostnader – med klare leveringstider.",
  },
  {
    n: "03",
    title: "Utførelse",
    desc: "Vårt eget team utfører jobben med presisjon og respekt for hjemmet ditt.",
  },
  {
    n: "04",
    title: "Overlevering",
    desc: "Vi går gjennom resultatet sammen og sikrer at alt fungerer som det skal – med dokumentasjon.",
  },
];

export default function Process() {
  return (
    <section id="prosess" className="relative py-24 sm:py-32 overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full bg-cyan/10 blur-[150px] pointer-events-none" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl mb-14 sm:mb-20">
          <div className="mono text-[11px] uppercase tracking-[0.3em] text-coral mb-5 reveal">
            / Prosess
          </div>
          <h2 className="reveal text-4xl sm:text-6xl font-bold text-white leading-[1]" data-testid="process-headline">
            Forutsigbart fra<br />første kontakt.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {STEPS.map((s, i) => (
            <div
              key={s.n}
              className="reveal relative p-7 rounded-3xl border hairline bg-[hsl(var(--hs-bg-2))] hover:border-cyan/40 transition-all duration-500 group"
              style={{ transitionDelay: `${i * 100}ms` }}
              data-testid={`process-step-${i}`}
            >
              <div className="flex items-baseline justify-between mb-10">
                <span className="text-6xl font-bold text-gradient leading-none">
                  {s.n}
                </span>
                <span className="mono text-[10px] uppercase tracking-[0.22em] text-white/40">
                  Steg
                </span>
              </div>
              <h3 className="text-2xl font-bold text-white mb-3">{s.title}</h3>
              <p className="text-white/60 text-[15px] leading-relaxed">{s.desc}</p>
              <div className="absolute bottom-0 left-7 right-7 h-px bg-gradient-to-r from-cyan/60 via-coral/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
